import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import TableContext from "context/table/tableContext";
import { ActionBarTitleLoader, useFormattedNumber } from "shared";

import { ContentFrameWithButtonProps } from "../types";

const ContentFrameWithButton = ({
    children,
    button
}: ContentFrameWithButtonProps) => {
    const { hasNoPermissionToRead, tableName, totalRows, isInitialLoading } =
        useContext(TableContext);

    const { t } = useTranslation();
    const { renderFormattedNumber } = useFormattedNumber();

    return (
        <>
            {isInitialLoading ? (
                <ActionBarTitleLoader
                    customStyle={{
                        "@media(max-width: 599px)": {
                            marginBottom: "8px"
                        }
                    }}
                />
            ) : (
                <div
                    css={css({
                        display: "flex",
                        alignItems: "center",

                        "& > span, & > button": {
                            marginLeft: "16px"
                        },

                        "@media(max-width: 599px)": {
                            justifyContent: "space-between",
                            marginBottom: "8px"
                        }
                    })}
                >
                    <h1>
                        <span>{t(`General##${tableName}`)}</span>

                        {!hasNoPermissionToRead && (
                            <span>({renderFormattedNumber(totalRows)})</span>
                        )}
                    </h1>

                    {button}
                </div>
            )}

            <div
                css={css({
                    display: "flex",
                    columnGap: "8px",

                    "@media(max-width: 599px)": {
                        display: "grid",
                        gridAutoFlow: "column",
                        gridAutoColumns: "1fr",
                        gridColumnGap: "16px"
                    }
                })}
            >
                {children}
            </div>
        </>
    );
};

export default ContentFrameWithButton;
